// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"37fd098d","26":"700dd7f2","209":"5d51093d","221":"b391add5","354":"5dfb456e","512":"db552b7a","519":"b321b528","563":"0c23cf8b","821":"a66b86a5"}[chunkId] + ".chunk.css";
};